export const mapOvertimeAccountDto = (dto) => ({
    id: dto.id,
    userId: dto.user_id,
    year: dto.year,
    month: dto.month,
    plannedTime: dto.planned_time,
    actualTime: dto.actual_time,
    overtime: dto.overtime,
    manualCorrection: dto.manual_correction,
    finalBalance: dto.final_balance,
    displayName: dto.user?.name ?? null,
});

export const mapTotalOvertimeBalance = (dto) => ({
    userId: dto.user_id,
    totalBalance: dto.total_balance,
    monthlyDetails: dto.monthly_details,
});
